import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        memberCarList: [],  // 客户添加的全部车辆列表
        defaultCar: null,   // 客户默认的车辆

        mallCartCount: 0,   // 商城购物车商品数量
        
        merchantInfo: null,   // 当前所在门店信息
        
        isHideNav: false,    // 是否隐藏底部导航按钮
        navigatorZIndex: 999,  // 底部导航栏层级
        
        temMerchantInfo: null,   // 分类页面上方显示的门店
        
        chooseProductTitle: '',    // 产品选择页面的title
        
        carWashMachineNo: '', //洗车机编号
    },
    mutations: {
        // 更新商城购物车数量
        updateCartCount(state, val) {
            state.mallCartCount = val;
        },

        // 更新客户默认车辆信息
        updateDefaultCar(state, val) {
            state.defaultCar = val;
        },
        // 更新车辆列表
        updateCarList(state, val){
            state.memberCarList = val;
        },

        // 更新当前所在门店信息
        updateMerchantInfo(state, val){
            state.merchantInfo = val;
        },
        
        updateNavStatus(state, val){
            state.isHideNav = val;
        },
        
        updateTemMerchant(state, val){
            state.temMerchantInfo = val;
        },
        
        updateChooseProductTitle(state, val){
            state.chooseProductTitle = val;
        },
        
        updateNavigatorZIndex(state, val){
            state.navigatorZIndex = val;
        },
        
        setCarWashMachineNo(state, val){
            state.carWashMachineNo = val;
        }
    },
    actions: {},
    modules: {}
})
